import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from '../../store/slices/auth-slice';
import { Roles } from '../consts/roles';

const LandingPage = () => {
  const loggedInUser = useSelector(selectLoggedInUser);

  let path = '';
  if (loggedInUser) {
    switch (loggedInUser.role.name) {
      case Roles.ROOT:
        path = '/car-houses';
        break;
      case Roles.ADMIN:
        path = '/vehicles';
        break;
      case Roles.CARHOUSEADMIN:
        path = '/vehicles';
        break;
      case Roles.USER:
        path = '/vehicles';
        break;
      default:
        break;
    }
  }

  return loggedInUser ? (
    <Navigate to={path} replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default LandingPage;
